/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

import styled from "styled-components";

import { BasePlate } from "src/classes/plate/BasePlate/BasePlate";
import { PageThumbnail } from "src/components/Shared/PageThumbnail";

interface Props {
  plates: BasePlate[];
}
export function RelatedPages({ plates }: Props) {
  return (
    <Wrapper>
      {plates.map((plate) => (
        <PageThumbnail
          key={plate.snapshot.id}
          plate={plate}
          wrapperStyles={{ width: "48%", marginBottom: "15px" }}
        />
      ))}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
`;
